import React from "react"
import PropTypes from "prop-types"
import ReactModal from "react-modal"

import theme from "styles/theme"

const customStyles = {
  content: {
    width: "100%",
    height: "100%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    position: "fixed",
    transform: "translate(-50%, -50%)",
    padding: "0",
    borderRadius: "0",
    border: "none",
    background: "transparent",
    zIndex: "102",
    backgroundColor: theme.color.white,
  },
  overlay: {
    zIndex: "101",
    backgroundColor: theme.color.white,
  },
}

const Modal = ({ showModal, children, handleCloseModal }) => {
  return (
    <>
      <ReactModal
        isOpen={showModal}
        style={customStyles}
        contentLabel="Exdev dialog"
        appElement={
          typeof document === "undefined"
            ? undefined
            : document.getElementById("___gatsby")
        }
        ariaHideApp
        onRequestClose={handleCloseModal}
        overlayClassName="Secondary"
      >
        {children}
      </ReactModal>
    </>
  )
}

Modal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  handleCloseModal: PropTypes.func.isRequired,
}

export default Modal
